<template>
  <div>
    <list-page-header />
    <yv-index
      ref="surveyTable"
      :columns="columns"
      :disabledHeaderActions="true"
      :enableExport="false"
      :formSearch="formSearch"
      :formatTableData="formatTableData"
      :path="path"
      :sortable="sortable"
      :tableActionsComponent="TableActions"
    >
    </yv-index>
    <!-- send-mail-survey -->
    <common-modal
      :name="currentSurvey.name"
      height="auto"
      title="common.share_email"
      width="70%"
    >
      <template #modal-body>
        <send-mail-form
          :dataMail="dataMail"
          :surveyId="surveyId"
          @hideModalSendMail="hideModalSendMail"
          @reFetchTableData="reFetchTableData"
        ></send-mail-form>
      </template>
    </common-modal>
  </div>
</template>

<script>
import { YvIndex } from "@/components/Base";
import { service_names } from "@/constants/Services";
import Header from "./Header";
import TableActions from "./TableActions.vue";
import { DEFAULT_OPTION_ALL } from "@/constants";
import CommonModal from "../../../components/Base/CommonModal.vue";
import SendMailForm from "./SendMailForm.vue";
import Swal from "sweetalert2";
import { getId, Message } from "@/helpers/utils";
import { formatDateClient } from "../../../helpers/datetime-helper";
import { mapGetters } from "vuex";

export default {
  name: "ListPage",
  components: { YvIndex, ListPageHeader: Header, CommonModal, SendMailForm },
  data() {
    const statusOptions = [
      ...DEFAULT_OPTION_ALL,
      {
        id: "Activated",
        name: "common.activated"
      },
      {
        id: "Archived",
        name: "common.archived"
      },
      {
        id: "Pending",
        name: "common.pending"
      }
    ];
    return {
      item: null,
      TableActions,

      path: `${service_names.school}/survey`,
      sortable: ["title", "full_name", "status"],
      columns: {
        title: this.$t("survey.col_name"),
        sent_date: this.$t("survey.sent_date"),
        full_name: this.$t("survey.create_by"),
        responded: this.$t("survey.responded"),
        status: this.$t("common.status")
      },
      formSearch: [
        {
          label: "survey.search_by_title",
          name: "title",
          value: "",
          type: "input"
        },
        {
          label: "program.filter_by_status",
          name: "status",
          value: "",
          type: "select",
          options: statusOptions
        },
        {
          label: "survey.sent_date",
          name: "sent_date",
          value: [],
          type: "date-range",
          width: 30
        }
      ],
      currentSurvey: {
        name: ""
      },
      dataMail: {},
      surveyId: null
    };
  },
  computed: {
    ...mapGetters("user", {
      userRole: "role",
      userTz: "timezone"
    })
  },
  methods: {
    convertTimezone(time, zone) {
      const moment = require("moment-timezone");
      if (!time) return "";
      if (zone)
        return moment(time + " ZZ", "YYYY-MM-DD hh:mm:ss ZZ")
          .tz(zone)
          .format(`${formatDateClient} HH:mm:ss`);
    },
    formatTableData(tableData) {
      return tableData.map(surveyData => {
        surveyData.title = `<p class="w-64 break-normal">${surveyData.gerneral_information.title}</p>`;
        surveyData.sent_date =
          surveyData.sent_date &&
          this.convertTimezone(surveyData.sent_date, this.userTz);
        surveyData.responded = `<p>${surveyData.responded}</p>`;
        return surveyData;
      });
    },
    confirmSendMail(item) {
      this.surveyId = getId(item);
      this.dataMail.status = "Activated";
      this.dataMail.gerneral_information = item.gerneral_information;
      this.dataMail.survey_structure = item.survey_structure;
      this.dataMail.email_content = item.email_content;
      this.$modal.show(this.currentSurvey.name);
    },
    hideModalSendMail() {
      this.$modal.hide(this.currentSurvey.name);
    },
    reFetchTableData() {
      return this.$refs.surveyTable.getTableData();
    },
    async deleteSurvey(data) {
      await this.$axios.delete(this.path + "/" + getId(data)).then(async () => {
        await this.reFetchTableData();
        Message.success(this.$t("common.delete_success"));
      });
    },
    confirmDelete(data) {
      Swal.fire({
        title: this.$t("common.confirmation"),
        text: this.$t("survey.text_confirm_delete"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-danger btn-fill",
        cancelButtonClass: "md-button md-secondary btn-fill",
        confirmButtonText: this.$t("common.delete"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteSurvey(data);
        }
      });
    }
  },
  provide() {
    return {
      confirmSendMail: this.confirmSendMail,
      confirmDelete: this.confirmDelete
    };
  }
};
</script>

<style lang="scss" scoped>
::v-deep .isis-modal-content .isis-modal-body[data-v-63dee958] {
  max-height: 100%;
}
</style>
